import PaginatedList from '@theme/paginated-list';

/** Collection and full-search results use one CSS-responsive grid. */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();
    // Retire only the former density preferences; never read or restore them.
    try {
      sessionStorage.removeItem('product-grid-view-desktop');
      sessionStorage.removeItem('product-grid-view-mobile');
    } catch {
      // Grid sizing remains CSS-driven when storage is unavailable.
    }
    this.setAttribute('initialized', '');
  }
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
